import { Funktion } from '../../model/LedningDto';

interface RoleListProps {
  roles: Funktion[];
}

export const RoleList: React.FC<RoleListProps> = ({ roles }) => (
  <>
    {roles.map((role, i) => {
      return (
        <span key={role.value}>
          {role.klartext}
          {i !== roles.length && <br />}
        </span>
      );
    })}
  </>
);
